// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";

class DTRAttachementFormPresenter extends BaseFormPresenter {
  onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
  }

  async save() {
    const collection = this.view.getCollectionName();
    // this.object.selectDate.forEach(async (data) => {
    //   const [timeManagement] = await Promise.all([
    //     findObjectUseCase().execute("daily_time_record", {
    //       where: {
    //         date: new Date(data[0]),
    //         "employee.id": this.object.employee.id,
    //       },
    //       keys: ["timeRecStats"],
    //     }),
    //   ]);
    //   if (timeManagement.length > 0) {
    //     timeManagement.map(async (record) => {
    //       const updateTimeSheet = {
    //         id: record.id,
    //         timeRecStats: [`${this.object.categoryType} TO DUTY`],
    //       };
    //       await upsertUseCase().execute("daily_time_record", updateTimeSheet);
    //     });
    //   }
    // });
    if (this.object.id) {
      this.change.id = this.object.id;
    } else {
      this.change.acl = this.view.getAcl();
    }
    // this.change.employee = { id: this.object.employee.id };
    try {
      await upsertUseCase().execute(collection, this.change);
      this.change = {};
      this.showSuccess("Success");
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default DTRAttachementFormPresenter;
